import React from 'react';
import PropTypes from 'prop-types';

export const renderText = (text, label) => {
    return (
        <div>
            <label>{label}</label>
            <div>{text}</div>
        </div>
    );
};

renderText.propTypes = {
    text: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
};
